import Header from "../../../components/layouts/header";
import Sidebar from "../../../components/layouts/sidebar";
import { APIRoutes } from "../../../utility/app-routes";
import { MasterCommonRecordPage } from "../../../components/common/common-master-record/master-common-record-page";

const FurnitureStatus: React.FC = () => {
	// Table Pagination

	return (
		<div className="page-inner">
			<>
				<MasterCommonRecordPage
					addUpdateApiUrl={APIRoutes.appUpdateFurnitureStatus}
					deleteApiUrl={APIRoutes.deleteFurnitureStatus}
					title="Furniture Status"
					getAllRecordApiUrl={APIRoutes.getAllFurnitureStatus}
				/>
			</>
		</div>
	);
};
export default FurnitureStatus;
